module.exports = __webpack_public_path__ + "static/media/sidebar-school.c6ada48f.svg";